import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

export function useApi() {
  const { idToken } = useAuth();

  return useMemo(() => {
    // Create authenticated API instance
    const authenticatedApi = {
      get: (url, config = {}) => {
        return api.get(url, {
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${idToken}`,
          },
        });
      },
      post: (url, data, config = {}) => {
        return api.post(url, data, {
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${idToken}`,
          },
        });
      },
      put: (url, data, config = {}) => {
        return api.put(url, data, {
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${idToken}`,
          },
        });
      },
      delete: (url, config = {}) => {
        return api.delete(url, {
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${idToken}`,
          },
        });
      },
    };

    return authenticatedApi;
  }, [idToken]);
}
